export function translateStatusLote(text) {
    if (!text) return '';
    switch (text.toUpperCase()) {
        case 'UP_FALHA':
            return 'Falha no upload';
        case 'NAO_INICIADO':
            return 'Não iniciado';
        case 'EM_AUDITORIA':
            return 'Em auditoria';
        case 'AGUARDANDO_CONSENSO':
            return 'Aguardando consenso';
        case 'AUDITADO':
            return 'Auditado';
        case 'AGUARDANDO_IA':
            return 'Aguardando IA';
    }
    return '';
}

export function translateStatusAuditoria(text, comAlteracao) {
    if (!text) return '';

    let lblAlteracao = ''
    if (typeof comAlteracao != 'undefined' && text == 'A') {
        if (comAlteracao) {
            lblAlteracao = ' - Com alterações';
        } else {
            lblAlteracao = ' - Sem alterações';
        }
    }

    let result = translateStatusAuditoriaDataset()[text];
    if (result) {
        return translateStatusAuditoriaDataset()[text] + lblAlteracao;
    }

    return '';
}

export function translateStatusAuditoriaDataset() {
    return {
        'NI': 'Não iniciado',
        'EA': 'Em Auditoria',
        'AC': 'Aguardando consenso',
        'CONSENSUADO': 'Consensuado',
        'A': 'Auditado',
        'W': 'Aguardando'
    }
}

export function drawStatusAuditoria(text, comAlteracao) {
  return `
    <div class="alert alert-${translateStatusAuditoriaDatasetColor()[text] || 'light'} p-2 m-0 text-nowrap " role="alert">
      ${translateStatusAuditoriaDatasetIcon()[text] || ''}
      ${translateStatusAuditoria(text, comAlteracao)}
    </div>
  `;
}

export function translateStatusAuditoriaDatasetColor() {
  return {
      'NI': 'danger',
      'EA': 'warning',
      'AC': 'info',
      'CONSENSUADO': 'success',
      'A': 'success',
      'W': 'light'
  }
}

export function translateStatusAuditoriaDatasetIcon() {
  return {
      'NI': '<i class="far fa-square me-1"></i>',
      'EA': '<i class="far fa-circle me-1"></i>',
      'AC': '<i class="fas fa-handshake me-1"></i>',
      'CONSENSUADO': '<i class="fas fa-handshake me-1"></i>',
      'A': '<i class="far fa-star me-1"></i>',
      'W': '<i class="fas fa-certificate me-1"></i>'
  }
}

export function statusRadio2Code(statusRadioVal) {
  switch (statusRadioVal) {
    case 'NAO_INICIADO': return 'NI';
    case 'EM_AUDITORIA': return 'EA';
    case 'AGUARDANDO_CONSENSO': return 'AC';
    case 'AUDITADO': return 'A';
    case 'TODOS':
    default: return '';
  }
}

export function statusLoteRadios(addTodos = false, addFalha = false, addConsenso = false, ocultarNaoIniciado = false) {
    var values = [
        { value: 'NAO_INICIADO', label: 'Não iniciado' },
        { value: 'EM_AUDITORIA', label: 'Em auditoria' },
        { value: 'AUDITADO', label: 'Auditado' }
    ];

    if (ocultarNaoIniciado) {
        values = values.filter(v => v.value !== 'NAO_INICIADO');
    }

    if (addConsenso) {
        const idx = values.findIndex(v => v.value === 'AUDITADO');
        values.splice(idx >= 0 ? idx : values.length, 0, { value: 'AGUARDANDO_CONSENSO', label: 'Aguardando consenso' });
    }
    
    if (addFalha) {
        values.unshift({ value: 'UP_FALHA', label: 'Falha no upload' });
    }
    if (addTodos) {
        values.unshift({ value: 'TODOS', label: 'Todos' });
    }
    return values;
}

export function statusGuiaRadios(addTodos = false, ocultarNaoIniciado = false) {
    var values = [
        { value: 'NAO_INICIADO', label: 'Não iniciado' },
        { value: 'EM_AUDITORIA', label: 'Em auditoria' },
        { value: 'AGUARDANDO_CONSENSO', label: 'Aguardando consenso' },
        { value: 'AUDITADO', label: 'Auditado' }
    ];
    if (ocultarNaoIniciado) {
        values = values.filter(v => v.value !== 'NAO_INICIADO');
    }
    if (addTodos) {
        values.unshift({ value: 'TODOS', label: 'Todos' });
    }
    return values;
}

/** Preferir statusExibicao do backend (T4 hospital) quando existir. */
export function labelStatusGuia(item) {
    if (!item) return '';
    if (item.statusExibicao) return item.statusExibicao;
    return translateStatusAuditoria(item.status, item.statusComAlteracao);
}

export function isVisaoHospitalConsenso() {
    try {
        const user = JSON.parse(localStorage.getItem('user') || 'null');
        if (!user || !user.modulosUsuarioStr) return false;
        return user.modulosUsuarioStr.split(',').includes('lotesConsensoHospital');
    } catch (e) {
        return false;
    }
}

/** Representante Hospital (2) ou Convênio (3): NI é exibido como Em auditoria. */
export function ocultaStatusNaoIniciado() {
    try {
        const user = JSON.parse(localStorage.getItem('user') || 'null');
        if (!user) return false;
        if (user.representacaoId === 2 || user.representacaoId === 3) return true;
        return isVisaoHospitalConsenso();
    } catch (e) {
        return false;
    }
}
